// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DataTableController from "./datatable_controller";
import DataTableExportableController from "./datatable_exportable_controller";
import DatepickerController from "./datepicker_controller";
import DebounceSubmitController from "./debounce_submit_controller";
import DisplayablePasswordController from "./displayable_password_controller";
import DropzoneController from "./dropzone_controller";
import DuplicateElementController from "./duplicate_element_controller";
import FilterFormController from "./filter_form_controller";
import ImageViewerController from "./image_viewer_controller";
import ExportInspectionRoundController from "./export_inspection_round_controller";
import MarkRemoveFileController from "./mark_remove_file_controller";
import MemberInspectionFormController from "./member_inspection_form_controller";
import MemberNavigationShortcutController from "./member_navigation_shortcut_controller";
import OffcanvasController from "./offcanvas_controller";
import PannellumController from "./pannellum_controller";
import PersistScrollController from "./persist_scroll_controller";
import PlotlyController from "./plotly_controller";
import SidenaveController from "./sidenav_controller";
import SlimSelectController from "./slim_select_controller";
import SorterController from "./sorter_controller";
import SubmitTargetFormController from "./submit_target_form_controller";
import ToastController from "./toast_controller";
import UserFormController from "./user_form_controller";

application.register("datatable", DataTableController);
application.register("datatable-exportable", DataTableExportableController);
application.register("datepicker", DatepickerController);
application.register("debounce-submit", DebounceSubmitController);
application.register("displayable-password", DisplayablePasswordController);
application.register("dropzone", DropzoneController);
application.register("duplicate-element", DuplicateElementController);
application.register("filter-form", FilterFormController);
application.register("image-viewer", ImageViewerController);
application.register("export-inspection-round", ExportInspectionRoundController);
application.register("mark-remove-file", MarkRemoveFileController);
application.register("member-inspection-form", MemberInspectionFormController);
application.register("member-navigation-shortcut", MemberNavigationShortcutController);
application.register("offcanvas", OffcanvasController);
application.register("pannellum", PannellumController);
application.register("persist-scroll", PersistScrollController);
application.register("plotly", PlotlyController);
application.register("sidenav", SidenaveController);
application.register("slim-select", SlimSelectController);
application.register("sorter", SorterController);
application.register("submit-target-form", SubmitTargetFormController);
application.register("toast", ToastController);
application.register("user-form", UserFormController);